const color = {
    pro: "#fbb03b",
    basic: "#a2d5fc"
}

export default color